const prefix = 'fal';
const iconName = 'table-cells';
const width = 512;
const height = 512;
const aliases = ['th'];
const unicode = 'f00a';
const svgPathData = 'M352 64v96H480V96c0-17.7-14.3-32-32-32H352zm-32 0H192v96H320V64zM160 64H64C46.3 64 32 78.3 32 96v64H160V64zM32 192V320H160V192H32zm0 160v64c0 17.7 14.3 32 32 32h96V352H32zm160 96H320V352H192v96zm160 0h96c17.7 0 32-14.3 32-32V352H352v96zM480 320V192H352V320H480zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM192 320H320V192H192V320z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
